import React, { memo } from 'react';
import {
  TableRow,
  TableCell,
  Typography,
  Stack,
  Chip,
  Checkbox,
} from '@mui/material';
import { Collection } from '@domain/product/models/Collection';

interface CollectionRowProps {
  collection: Collection;
  isSelected?: boolean;
  onSelect?: (collection: Collection, selected: boolean) => void;
  onCollectionClick?: (collection: Collection) => void;
}

const CollectionRow: React.FC<CollectionRowProps> = ({
  collection,
  isSelected,
  onSelect,
  onCollectionClick,
}) => {
  const handleClick = () => {
    onCollectionClick?.(collection);
  };

  const handleSelect = (selected: boolean) => {
    onSelect?.(collection, selected);
  };

  return (
    <TableRow
      hover
      onClick={handleClick}
      sx={{
        cursor: 'pointer',
        '& td': {
          borderBottom: 1,
          borderColor: 'divider',
          p: 4,
        },
      }}
    >
      <TableCell sx={{ px: 3 }}>
        <Typography
          variant="body2"
          sx={{
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {collection.name}
        </Typography>
      </TableCell>
      <TableCell sx={{ px: 3 }}>
        <Stack direction="row" gap={0.5} flexWrap="wrap">
          {collection.products && collection.products.length > 0 ? (
            <>
              {collection.products.slice(0, 3).map((product) => (
                <Chip
                  key={product.id}
                  label={product.title || 'Untitled'}
                  size="small"
                  sx={{
                    maxWidth: 120,
                    '& .MuiChip-label': {
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    },
                  }}
                />
              ))}
              {(collection.products?.length ?? 0) > 3 && (
                <Chip
                  label={`+${collection.products!.length - 3}`}
                  size="small"
                  variant="outlined"
                />
              )}
            </>
          ) : (
            <Typography variant="body2" color="text.secondary">
              —
            </Typography>
          )}
        </Stack>
      </TableCell>
    </TableRow>
  );
};

export default memo(CollectionRow);
